import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CustomerView.css";

function CustomerView() {
  const [vinos, setVinos] = useState([]);
  const [filtros, setFiltros] = useState({
    nombre: "",
    region: "",
    tipo: "",
    variedad_uva: "",
    maridaje: "",
    precio: [0, 1000],
  });
  const [categorias, setCategorias] = useState([]);
  const [uvas, setUvas] = useState([]);
  const [maridajes, setMaridajes] = useState([]);
  const [modalVino, setModalVino] = useState(null);
  const [precioMaximo, setPrecioMaximo] = useState(1000);
  const [verDescripcionCompleta, setVerDescripcionCompleta] = useState(false);

  useEffect(() => {
    axios
      .get("http://localhost:5000/vinos")
      .then((response) => {
        const vinosData = response.data;
        setVinos(vinosData);

        const maxPrecio = Math.max(...vinosData.map((vino) => vino.precio));
        setPrecioMaximo(maxPrecio);
        setFiltros((prev) => ({ ...prev, precio: [0, maxPrecio] }));

        const tiposUnicos = [...new Set(vinosData.map((vino) => vino.tipo))];
        setCategorias(tiposUnicos);

        const uvasUnicas = [...new Set(vinosData.map((vino) => vino.variedad_uva))];
        setUvas(uvasUnicas);

        const maridajesUnicos = [
          ...new Set(vinosData.flatMap((vino) => (vino.maridaje || "").split(", "))),
        ];
        setMaridajes(maridajesUnicos);
      })
      .catch((error) => console.error("Error al cargar los vinos:", error));
  }, []);

  const abrirModal = (vino) => {
    setModalVino(vino);
    setVerDescripcionCompleta(false);
  };

  const cerrarModal = () => setModalVino(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        cerrarModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const vinosFiltrados = vinos.filter(
    (vino) =>
      (filtros.nombre
        ? vino.nombre.toLowerCase().includes(filtros.nombre.toLowerCase())
        : true) &&
      (filtros.region ? vino.region === filtros.region : true) &&
      (filtros.tipo ? vino.tipo === filtros.tipo : true) &&
      (filtros.variedad_uva ? vino.variedad_uva === filtros.variedad_uva : true) &&
      (filtros.maridaje
        ? (vino.maridaje || "").toLowerCase().includes(filtros.maridaje.toLowerCase())
        : true) &&
      vino.precio >= filtros.precio[0] &&
      vino.precio <= filtros.precio[1]
  );

  const truncateDescripcion = (descripcion) => {
    const maxLength = 150;
    return descripcion.length > maxLength
      ? descripcion.slice(0, maxLength) + "..."
      : descripcion;
  };

  return (
    <div className="customer-view">
      <h1>Explora Nuestra Cava</h1>

      {/* Filtros */}
      <div className="filtros">
        <input
          type="text"
          placeholder="Buscar por nombre"
          value={filtros.nombre}
          onChange={(e) => setFiltros({ ...filtros, nombre: e.target.value })}
        />
        <select
          value={filtros.region}
          onChange={(e) => setFiltros({ ...filtros, region: e.target.value })}
        >
          <option value="">Todas las Regiones</option>
          {[...new Set(vinos.map((vino) => vino.region))].map((region) => (
            <option key={region} value={region}>
              {region}
            </option>
          ))}
        </select>
        <select
          value={filtros.tipo}
          onChange={(e) => setFiltros({ ...filtros, tipo: e.target.value })}
        >
          <option value="">Todos los Tipos</option>
          {categorias.map((tipo) => (
            <option key={tipo} value={tipo}>
              {tipo}
            </option>
          ))}
        </select>
        <select
          value={filtros.variedad_uva}
          onChange={(e) => setFiltros({ ...filtros, variedad_uva: e.target.value })}
        >
          <option value="">Todas las Variedades de Uva</option>
          {uvas.map((uva) => (
            <option key={uva} value={uva}>
              {uva}
            </option>
          ))}
        </select>
        <select
          value={filtros.maridaje}
          onChange={(e) => setFiltros({ ...filtros, maridaje: e.target.value })}
        >
          <option value="">Todos los Maridajes</option>
          {maridajes.map((maridaje) => (
            <option key={maridaje} value={maridaje}>
              {maridaje}
            </option>
          ))}
        </select>
        <div className="filtro-precio">
          <label>
            Rango de Precios: ${filtros.precio[0]} - ${filtros.precio[1]}
          </label>
          <input
            type="range"
            min="0"
            max={precioMaximo}
            step="10"
            value={filtros.precio[0]}
            onChange={(e) =>
              setFiltros({
                ...filtros,
                precio: [Number(e.target.value), filtros.precio[1]],
              })
            }
          />
          <input
            type="range"
            min="0"
            max={precioMaximo}
            step="10"
            value={filtros.precio[1]}
            onChange={(e) =>
              setFiltros({
                ...filtros,
                precio: [filtros.precio[0], Number(e.target.value)],
              })
            }
          />
        </div>
      </div>

      {/* Listado de Vinos */}
      <div className="vinos-lista">
        {vinosFiltrados.map((vino) => (
          <div
            key={vino.id}
            className="vino-tarjeta-horizontal"
            onClick={() => abrirModal(vino)}
          >
            <img
              src={vino.etiqueta_url || "https://via.placeholder.com/300"}
              alt={vino.nombre}
              className="vino-imagen-horizontal"
            />
            <div className="vino-detalles">
              <h3>{vino.nombre}</h3>
              <p><strong>Región:</strong> {vino.region}</p>
              <p><strong>Tipo:</strong> {vino.tipo}</p>
              <p><strong>País:</strong> {vino.pais}</p>
              <p>${vino.precio.toFixed(2)}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de Detalles */}
      {modalVino && (
        <div className="modal" onClick={cerrarModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={cerrarModal}>
              ×
            </button>
            <img
              src={modalVino.etiqueta_url || "https://via.placeholder.com/300"}
              alt={modalVino.nombre}
              className="vino-modal-imagen"
            />
            <h2>{modalVino.nombre}</h2>
            <p>
              <strong>Región:</strong> {modalVino.region}
            </p>
            <p>
              <strong>Tipo:</strong> {modalVino.tipo}
            </p>
            <p>
              <strong>País:</strong> {modalVino.pais}
            </p>
            <p>
              <strong>Variedad de Uva:</strong> {modalVino.variedad_uva}
            </p>
            <p>
              <strong>Descripción:</strong>{" "}
              {verDescripcionCompleta
                ? modalVino.descripcion
                : truncateDescripcion(modalVino.descripcion)}
            </p>
            {modalVino.descripcion.length > 150 && (
              <button
                className="ver-mas-button"
                onClick={() => setVerDescripcionCompleta(!verDescripcionCompleta)}
              >
                {verDescripcionCompleta ? "Ver Menos" : "Ver Más"}
              </button>
            )}
            <p>
              <strong>Precio:</strong> ${modalVino.precio.toFixed(2)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerView;
